import { Select } from '@cimpress/react-components';
import React from 'react';

interface ConstraintOption {
    value: string;
    label: string;
}

interface Props {
    currentValue?: ConstraintOption;
    hide?: boolean;
    options?: ConstraintOption[];
    onToggleAspectRatioConstraint: (item: ConstraintOption) => void;
}

const Constraints: React.FC<Props> = ({ currentValue, hide, onToggleAspectRatioConstraint, options }) => {
    if (hide) {
        return null;
    }

    return (
        <div className='product-ar-constraint'>
            <Select
                label='Constrain to Product Aspect Ratio by'
                value={currentValue}
                options={options}
                onChange={onToggleAspectRatioConstraint}
            />
        </div>
    );
};

export default React.memo(Constraints);
